import moment from "moment";

const padNum = (str, size) => str.padStart(size, "0");
const fieldStr = (e, size) => padNum(e.value, size);
const getField = (form, pattern) => form.querySelector(`select[id$="${pattern}"]`);

document.addEventListener("DOMContentLoaded", () => {
  window.setTimeout(() => {
    monitorDatetimeSelectInputs();
    fixUtcDatetimes();
  }, 0);
});

function fixUtcDatetimes() {
  $(".utc-datetime").each(function () {
    let utc = $(this).data("utc-datetime");
    let localDatetime = moment.utc(utc).local().format("DD/MM/YYYY HH:mm");
    $(this).text(localDatetime);
  });
}

function monitorDatetimeSelectInputs() {
  // Seek for <div /> elements with class '.livestream__datetime-form'
  //
  const datetimes = document.querySelectorAll(".livestream__datetime-form");
  for (let form of datetimes) {
    const dateForm = form;
    const eYear = getField(dateForm, "year");
    const eMonth = getField(dateForm, "month");
    const eDay = getField(dateForm, "day");
    const eHour = getField(dateForm, "hour");
    const eMinute = getField(dateForm, "minute");
    const eInput = form.querySelector('input[type="hidden"]');

    function buildDateFromFields() {
      const year = fieldStr(eYear, 4);
      const month = fieldStr(eMonth, 2);
      const day = fieldStr(eDay, 2);
      const hour = fieldStr(eHour, 2);
      const minute = fieldStr(eMinute, 2);
      return `${year}-${month}-${day}T${hour}:${minute}`;
    }

    // ... convert (hidden) UTC datetime into the local timezone.
    const datetimeLocal = moment.utc(eInput.value).local();

    // ... update each field
    eYear.value = datetimeLocal.year();
    eMonth.value = datetimeLocal.month() + 1;
    eDay.value = datetimeLocal.date();
    eHour.value = datetimeLocal.hour();
    eMinute.value = datetimeLocal.minute();

    // When the user changes a field, we must update the hidden UTC field
    const changeFn = () => {
      const dateStr = buildDateFromFields();
      const localDate = moment(dateStr);
      const utcDateStr = `${localDate.utc().format("YYYY-MM-DD HH:mm")}:00Z`;
      eInput.value = utcDateStr;
    };

    eYear.addEventListener("change", changeFn);
    eMonth.addEventListener("change", changeFn);
    eDay.addEventListener("change", changeFn);
    eHour.addEventListener("change", changeFn);
    eMinute.addEventListener("change", changeFn);
  }
}
